const Data = [
  {
    id: 1,
    name: "Word Game",
    image: "../photos/ss3.jpg",
    skills: [{ info: "JavaScript" }, { info: "CSS" }],
    details:
      "Developed an engaging vocabulary game where players create words by adding one letter at a time.",
    codeLink: "https://github.com/Cvanshulll/Word_Game",
    demoLink: "https://cvanshulll.github.io/Search_Profiles/"
  },
  {
    id: 2,
    name: "OP_Updates",
    image: "../photos/op-updates.jpg",
    skills: [
      { info: "React" },
      { info: "Django Rest Framework" },
      { info: "API design" },
      { info: "Problem-Solving" }
    ],
    details:
      "Developed OP_Updates, a responsive web application that retrieves job opportunities from an API endpoint and displays them to the user.",
    codeLink: "https://github.com/Cvanshulll/OP_Updates_frontend",
    demoLink: "https://opupdates.netlify.app/"
  },
  {
    id: 3,
    name: "TextUtils",
    image: "../photos/textutils.jpg",
    skills: [{ info: "React" }, { info: "Bootstrap" }],
    details:
      "It is a simple project TextUtils in which we can Analyze text, convert to upper and lower case and also we can copy text, remove extra spaces, and more. ",
    codeLink: "https://github.com/Cvanshulll/TextUtils",
    demoLink: "https://textproanalyser.netlify.app/"
  },
  {
    id: 4,
    name: "Notes App",
    image: "../photos/notes.jpg",
    skills: [{ info: "HTML" }, { info: "JavaScript" }],
    details:
      "User interactive website which allows users to add, search and delete notes.",
    codeLink: "https://github.com/Cvanshulll/Notes_app",
    demoLink: "https://cvanshulll.github.io/Notes_app/"
  },
  {
    id: 5,
    name: "Search Profiles",
    image: "../photos/cp_profiles.jpg",
    skills: [{ info: "HTML" }, { info: "CSS" }, { info: "Javascript" }],
    details:
      "The objective was to create a simple web app that finds users on different platforms ( Codeforces, Codechef, and Github).",
    codeLink: "https://github.com/Cvanshulll/Search_Profiles",
    demoLink: "https://cvanshulll.github.io/Search_Profiles/"
  },
  // {
  //   id: 6,
  //   name: "Product Landing Page",
  //   image:
  //     "https://cvanshulll.github.io/Vanshul-s_Portfolio/Images/product.jpg",
  //   skills: [{ info: "HTML" }, { info: "CSS" }],
  //   details: "Built responsive Product Landing Page, using HTML and CSS.",
  //   codeLink: "https://codepen.io/cvanshulll/full/RwgbpaR",
  //   demoLink: "https://codepen.io/cvanshulll/full/RwgbpaR"
  // },
  {
    id: 6,
    name: "Personal Chat Assistance",
    image: "https://cvanshulll.github.io/Vanshul-s_Portfolio/Images/chat.png",
    skills: [{ info: "Python" }, { info: "Beautiful Soup" }],
    details:
      "An interface that will give an option to search like a google search engine. Extracted the data using Beautiful Soup",
    codeLink: "https://github.com/Cvanshulll/Personal_Chat_Assistance"
    // demoLink: "not found"
  },
  // {
  //   id: 8,
  //   name: "Survey Form",
  //   image: "../photos/survey.jpg",
  //   skills: [{ info: "Html" }, { info: "Css" }],
  //   details:
  //     "Built a responsive survey form using HTML and CSS. I used the online editor Codepen to build my project.",
  //   codeLink: "https://codepen.io/cvanshulll/full/XWROXre",
  //   demoLink: "https://"
  // },
  {
    id: 7,
    name: "Spam Classification",
    image: "https://cvanshulll.github.io/Vanshul-s_Portfolio/Images/spam.png",
    skills: [{ info: "Python" }, { info: "Beautiful Soup" }],
    details:
      "Built a predictive model to classify that a given e-mail as spam or ham. Employed advanced classification algorithms such as Naive Bayes - a statistical technique of e-mail filtering",
    codeLink: "https://github.com/Cvanshulll/Spam-Classification",
    demoLink: "not found"
  }
  // {
  //   id: 9,
  //   name: "Netflix Clone",
  //   image: "../photos/netflix.jpg",
  //   skills: [{ info: "Python" }, { info: "Beautiful Soup" }],
  //   details:
  //     "Built a responsive website using HTML and CSS. With this project, I learned how to manage a long code by mentioning every detail in the comments for further reference. I used the online editor Codepen to build my project.",
  //   codeLink: "https://github.com/Cvanshulll/Spam-Classification",
  //   demoLink: "https://codepen.io/cvanshulll/full/qBmQKgj"
  // }
];

export default Data;
